import { IntlShape } from 'react-intl';
import { STUDIO_THEMES } from 'fym-shared/src/music24/studioThemes';
import { kitVariantLabel } from '../../kitLabels';
import { studioThemeMessages } from '../../studio/studioThemeMessages';
import { RevisionCard } from './revisionCards';

/**
 * The name of a card (design c1): "Story (Out now)", "Cover sizes (3000 × 3000)", "Short video",
 * "AI reel 30s". The variant shows when the asset type makes more than one file or has moments.
 */
export function revisionCardLabel(intl: IntlShape, card: RevisionCard): string {
  const name = intl.formatMessage(studioThemeMessages[card.themeId].name);
  if (card.kind === 'reel') {
    return `${name} ${card.variant}`;
  }
  const { asset } = card;
  const namesVariant =
    card.themeId === 'story' || card.themeId === 'feedPost' || STUDIO_THEMES[card.themeId].outputs.length > 1;
  if (asset === null || !namesVariant) {
    return name;
  }
  return `${name} (${kitVariantLabel(intl, { variant: asset.variant, specId: asset.specId })})`;
}
